import React, { createContext, useContext, useState, useCallback } from 'react';
import Modal from '../components/Modal';

const ModalContext = createContext();

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [modalConfig, setModalConfig] = useState(null);

  const showModal = useCallback((config) => {
    setModalConfig(config);
  }, []);

  const hideModal = useCallback(() => {
    setModalConfig(null);
  }, []);

  // Replacement for window.alert
  const showAlert = useCallback((message, type = 'info') => {
    showModal({
      title: type.charAt(0).toUpperCase() + type.slice(1),
      message,
      type,
      confirmText: 'OK',
      onConfirm: hideModal
    });
  }, [showModal, hideModal]);

  // Replacement for window.confirm
  const showConfirm = useCallback((message, onConfirm, onCancel = () => {}) => {
    showModal({
      title: 'Confirm Action',
      message,
      type: 'warning',
      confirmText: 'Yes, Proceed',
      cancelText: 'Cancel',
      onConfirm: () => {
        onConfirm();
        hideModal();
      },
      onCancel: () => {
        onCancel();
        hideModal();
      }
    });
  }, [showModal, hideModal]);

  const showSuccess = useCallback((message) => showAlert(message, 'success'), [showAlert]);
  const showError = useCallback((message) => showAlert(message, 'error'), [showAlert]);

  return (
    <ModalContext.Provider value={{ showModal, hideModal, showAlert, showConfirm, showSuccess, showError }}>
      {children}
      {modalConfig && (
        <Modal
          {...modalConfig}
          onClose={hideModal}
        />
      )}
    </ModalContext.Provider>
  );
};
